module.exports = __webpack_public_path__ + "static/_0003_ZED-14dad6b6b69db6a1af086213878f1c2e.jpg";